import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'ca-toggle-advanced-edit',
    templateUrl: './toggle-advanced-edit.component.html',
    standalone: false
})
export class ToggleAdvancedEditComponent {
    @Input() toggleModel: boolean
    @Input() message: string
    @Input('name') toggleName: string
    @Input() tooltip: string
    @Input() tooltipType: string
    @Input() labels: boolean = true
    @Input() disabled: boolean = false
    @Output() callback = new EventEmitter<any>()

    constructor() {
    }

    toggle(): void {
        this.callback.emit({ $toggle: this.toggleModel })
    }
}